"use strict";

var _interopRequireWildcard = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js");
var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.array.find");
require("core-js/modules/es6.number.constructor");
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.map");
var _axios = _interopRequireDefault(require("axios"));
var echarts = _interopRequireWildcard(require("echarts"));
var _index = require("@/utils/index");
var _InfoItem = _interopRequireDefault(require("@/components/Store/InfoItem.vue"));
var _homeReport = require("@/http/interface/sfe/homeReport");
var _methods = require("@/components/Store/SalesKPIRecord/methods");
var _saleTextBoard = _interopRequireDefault(require("@/views/dashboard/components/saleTextBoard.vue"));
var _mixBoard = _interopRequireDefault(require("@/views/dashboard/components/mixBoard.vue"));
var _headerMore = _interopRequireDefault(require("@/views/dashboard/components/headerMore.vue"));
var _integralTextBoard = _interopRequireDefault(require("@/views/dashboard/components/integralTextBoard.vue"));
var _TargetValue = _interopRequireDefault(require("@/views/dashboard/components/TargetValue.vue"));
var _vuex = require("vuex");
var _index2 = _interopRequireDefault(require("@/components/Common/Model/index.vue"));
var _shop = _interopRequireDefault(require("@/views/dashboard/components/shop.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 引入图表
/** package */

/** components */

/** services */

/** utils */

var curDateTree = (0, _methods.getCurDateTree)(); // 获取当前时间相关 月份、季度、年份
var mapObj = new Map();
mapObj.set('1', curDateTree.month);
mapObj.set('2', curDateTree.quarter);
mapObj.set('3', curDateTree.year);
var _default = exports.default = {
  name: 'HomeAsm',
  components: {
    Shop: _shop.default,
    Model: _index2.default,
    TargetValue: _TargetValue.default,
    IntegralTextBoard: _integralTextBoard.default,
    HeaderMore: _headerMore.default,
    MixBoard: _mixBoard.default,
    SaleTextBoard: _saleTextBoard.default,
    InfoItem: _InfoItem.default
  },
  // srEmpNo 这个页面应该不会再用到了 不过以防万一 没删代码 涉及到的接口应该也没有使用
  props: {
    srEmpNo: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      isSales: 'sales',
      currentType: 'CNY',
      saleDisplayData: {},
      target_EV: {},
      target_LUX: {},
      target_SUV: {},
      mixData_18: {},
      // Mix_18
      mixData_19: {},
      mixData_20: {},
      newProductsData: [],
      // 新产品
      saleIntegralData: {},
      storeData: {
        activeRateNum: 0,
        signRateNum: 0
      },
      showSalary: false,
      salary: 0,
      bonusMonth: '1.5',
      salaryRes: 0,
      lookupList: {
        BONUS_CALCULATION_MONTH_MAPPING: {}
      },
      storeAllData: {},
      /** tpp form */
      ssbtypeOptions: [{
        name: this.$t('storeComponents.title.GY'),
        code: 'GY'
      }, {
        name: this.$t('storeComponents.title.CP'),
        code: 'CP'
      }],
      // 枚举，目前写死
      salesForm: {
        type: '1',
        // 类型 月度、季度、年度
        brand: 'GY',
        // 品牌 目前写死option，并写死一个默认值
        value: ''
      },
      storeForm: {
        // 门店
        month: mapObj.get('1')
      },
      tppSourceApi: null,
      salesInfo: {},
      tppSignInfo: {
        rateNum: 0
      },
      tppActiveInfo: {
        rateNum: 0
      },
      tppActiveInfoQuarter: {
        rateNum: 0
      },
      /** order form */
      orderForm: {
        month: curDateTree.month // 月份 demo 202307
      },
      /** report form */
      reportForm: {
        month: curDateTree.month // 月份 demo 202307
      },
      /** 订单情况 */
      orderStatus: {
        salesTargetQty: 0,
        confirmedQty: 0,
        orderQty: 0
      },
      /** 月度拜访报告 */
      monthVisitReport: {
        visitDayQty: 0,
        visitQty: 0
      },
      orderSourceApi: null,
      reportSourceApi: null,
      /** echart */
      SALESChat: null // TPP达成量 图表
    };
  },
  computed: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['roles'])), {}, {
    // 时间lable格式化
    formatTimeLabel: function formatTimeLabel() {
      var tree = {
        1: this.$t('storeComponents.select.month'),
        2: this.$t('storeComponents.select.quarter'),
        3: this.$t('storeComponents.select.year')
      };
      var type = this.salesForm.type;
      if (type && tree[type]) {
        return tree[type];
      } else {
        return '';
      }
    },
    // api请求用到的全局部分的params
    baseParams: function baseParams() {
      var roles = this.$store.getters.roles || []; // 当前角色
      var _ref = this.$store.state.user || {},
        userInfo = _ref.userInfo;
      var empNo = userInfo.empNo || '';
      return {
        empNo: empNo,
        // 工号
        roleCode: roles[0] // 角色
      };
    },
    // 进度条百分比
    orderPecent: function orderPecent() {
      var _this$orderStatus = this.orderStatus,
        salesTargetQty = _this$orderStatus.salesTargetQty,
        confirmedQty = _this$orderStatus.confirmedQty,
        orderQty = _this$orderStatus.orderQty;
      return {
        salesTargetQty: salesTargetQty ? 100 : 0,
        confirmedQty: this.getPercent(confirmedQty, salesTargetQty),
        orderQty: this.getPercent(orderQty, salesTargetQty)
      };
    }
  }),
  watch: {
    'isSales': function isSales(val, oldVal) {
      if (val !== oldVal) {
        if (val === 'integral') {
          this.salesForm.type = '2';
          this.fetchSaleIntegralData();
        } else if (val === 'store') {
          this.salesForm.type = '2';
        } else {
          this.fetchSaleDisplayData();
        }
      }
    },
    'salesForm.type': {
      deep: true,
      immediate: true,
      handler: function handler(val, oldVal) {
        // console.log(1, val, oldVal)
        var typeNum = Number(val);
        if (typeNum === 1) {
          // 月度
          this.salesForm.value = curDateTree.month;
        } else if (typeNum === 2) {
          // 季度
          this.salesForm.value = curDateTree.quarter;
        } else if (typeNum === 3) {
          // 年度
          this.salesForm.value = curDateTree.year;
        }
        // SR/DA/Training 除在积分/门店状态下 的切换type都初始化isSales值
        if (!(typeNum === 2 && (this.isSales === 'integral' || this.isSales === 'store'))) {
          this.isSales = 'sales';
        }
      }
    },
    'salesForm.brand': {
      deep: true,
      handler: function handler(val, oldVal) {
        // console.log(2, val, oldVal)
        if (val !== oldVal) {
          this.initEcharts();
        }
      }
    },
    'salesForm.value': {
      deep: true,
      handler: function handler(val, oldVal) {
        // console.log(2, val, oldVal)
        if (val !== oldVal) {
          this.initLeftData();
        }
      }
    },
    'orderForm.month': {
      deep: true,
      handler: function handler(val, oldVal) {
        if (val !== oldVal) {
          this.initOrderStatus();
        }
      }
    },
    'reportForm.month': {
      deep: true,
      handler: function handler(val, oldVal) {
        if (val !== oldVal) {
          this.initMonthVisitReport();
        }
      }
    },
    '$store.getters.language': function $storeGettersLanguage(newValue) {
      // 监听语言变更刷新图表
      this.initLeftData();
      this.getLookupTypeCode();
    },
    srEmpNo: function srEmpNo(newValue) {
      // 监听SR详情角色变更刷新图表数据
      this.initEcharts();
    },
    'storeForm.month': {
      deep: true,
      handler: function handler(val, oldVal) {
        if (val !== oldVal) {
          // 门店
          this.fetchStoreALLData();
        }
      }
    }
  },
  mounted: function mounted() {
    var _this = this;
    // echart初始化
    this.SALESChat = echarts.init(document.getElementById('id_salesCompRate'));
    // 因为依赖外部数据，所以初始化操作放在外部读取完门店数据后
    this.$nextTick(function () {
      // 画图
      _this.initEcharts();
    });
    this.getLookupTypeCode();
  },
  methods: {
    // 初始化 所有图表
    initEcharts: function initEcharts() {
      this.initLeftData();
      this.initOrderStatus();
      this.initMonthVisitReport();
      this.fetchStoreALLData();
    },
    initLeftData: function initLeftData() {
      // 根据tab 调用的接口
      this.fetchSaleDisplayData();
      this.fetchSaleIntegralData();
      this.fetchNewProductsData();
      this.fetchMixData();
      this.fetchStoreData();
    },
    // 获取百分比
    getPercent: function getPercent(z, m) {
      if (z && z > m) {
        // 分子存在并且大于分母，不管分母是不是0，就是100进度
        return 100;
      } else if (z && m) {
        // const num = Math.ceil(z / m * 100)
        return Math.ceil(z / m * 100);
      } else {
        return 0;
      }
    },
    // 标准化百分比
    standardPercent: function standardPercent(percent) {
      if (percent > 100) {
        return 100;
      } else if (percent < 0) {
        return 0;
      }
      return percent;
    },
    // 初始化 TPP达成量 没在使用
    initSALESCompRate: function initSALESCompRate() {
      var _this2 = this;
      var _this$salesForm = this.salesForm,
        brand = _this$salesForm.brand,
        value = _this$salesForm.value;
      if (!brand || !value) {
        // 所有参数必传
        console.log('tpp 所有参数必传', this.salesForm);
        return false;
      }
      if (this.tppSourceApi) {
        this.tppSourceApi.cancel('cancel');
      }
      this.tppSourceApi = _axios.default.CancelToken.source();
      var params = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.salesForm), {}, {
        srEmpNo: this.srEmpNo,
        version: this.srEmpNo ? 2 : null
      });
      // 数据更新时环形图先归零
      (0, _methods.drawSales)(this.SALESChat, {});
      (0, _homeReport.getReportSales)(params, this.tppSourceApi.token).then(function (res) {
        var data = res.data || {};
        var salesInfo = {
          color: data.color || '#000000',
          salesCount: data.salesCount || 0,
          seventeenCount: data.seventeenCount || 0,
          eighteenCount: data.eighteenCount || 0,
          finishSalesRate: data.finishSalesRate || 0,
          finishSeventeenRate: data.finishSeventeenRate || 0,
          finishEighteenRate: data.finishEighteenRate || 0,
          targetSalesCount: data.targetSalesCount || 0,
          targetSeventeenCount: data.targetSeventeenCount || 0,
          targetEighteenCount: data.targetEighteenCount || 0,
          unFinishSalesCount: data.unFinishSalesCount || 0,
          unFinishSeventeenCount: data.unFinishSeventeenCount || 0,
          unFinishEighteenCount: data.unFinishEighteenCount || 0,
          mixSeventeenRate: data.mixSeventeenRate || 0,
          mixEighteenRate: data.mixEighteenRate || 0
        };
        // 延时更新避免动画顺序有问题
        setTimeout(function () {
          (0, _methods.drawSales)(_this2.SALESChat, salesInfo);
        }, 500);
        // 数据
        _this2.salesInfo = salesInfo;
      });
    },
    // 初始化 门店情况 没在使用
    initStoreStatus: function initStoreStatus() {
      var _this3 = this;
      (0, _homeReport.getReportSigningMonth)({
        srEmpNo: this.srEmpNo
      }).then(function (res) {
        _this3.tppSignInfo = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, res.data), {}, {
          rateNum: res.data.signingCount > 0 && res.data.signingTargetCount === 0 ? 100 : res.data.rate && parseInt(res.data.rate) || 0,
          rate: res.data.signingCount > 0 && res.data.signingTargetCount === 0 ? '-' : res.data.rate
        });
      });
      (0, _homeReport.getReportActiveMonth)({
        srEmpNo: this.srEmpNo
      }).then(function (res) {
        _this3.tppActiveInfo = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, res.data), {}, {
          rateNum: res.data.activeCount > 0 && res.data.activeTargetCount === 0 ? 100 : res.data.rate && parseInt(res.data.rate) || 0,
          rate: res.data.activeCount > 0 && res.data.activeTargetCount === 0 ? '-' : res.data.rate
        });
      });
      (0, _homeReport.getReportActiveQuarter)({
        srEmpNo: this.srEmpNo
      }).then(function (res) {
        _this3.tppActiveInfoQuarter = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, res.data), {}, {
          rateNum: res.data.activeCount > 0 && res.data.activeTargetCount === 0 ? 100 : res.data.rate && parseInt(res.data.rate) || 0,
          rate: res.data.activeCount > 0 && res.data.activeTargetCount === 0 ? '-' : res.data.rate
        });
      });
    },
    // 初始化 订单情况
    initOrderStatus: function initOrderStatus() {
      var _this4 = this;
      var brand = this.salesForm.brand;
      var month = this.orderForm.month;
      if (!brand || !month) {
        // 所有参数必传
        console.log('订单情况 所有参数必传', this.orderForm);
        return false;
      }
      if (this.orderSourceApi) {
        this.orderSourceApi.cancel('cancel');
      }
      this.orderSourceApi = _axios.default.CancelToken.source();
      var params = (0, _objectSpread2.default)((0, _objectSpread2.default)({
        brand: this.salesForm.brand
      }, this.orderForm), {}, {
        srEmpNo: this.srEmpNo,
        version: this.srEmpNo ? 2 : null
      });
      (0, _homeReport.getReportOrderSales)(params, this.orderSourceApi.token).then(function (res) {
        var data = res.data || {};
        var _ref2 = data || {},
          salesTargetQty = _ref2.salesTargetQty,
          confirmedQty = _ref2.confirmedQty,
          orderQty = _ref2.orderQty;
        _this4.orderStatus.salesTargetQty = salesTargetQty || 0;
        _this4.orderStatus.confirmedQty = confirmedQty || 0;
        _this4.orderStatus.orderQty = orderQty || 0;
      });
    },
    // 初始化月度拜访报告
    initMonthVisitReport: function initMonthVisitReport() {
      var _this5 = this;
      var month = this.reportForm.month;
      if (!month) {
        // 所有参数必传
        console.log('订单情况 所有参数必传', this.reportForm);
        return false;
      }
      if (this.reportSourceApi) {
        this.reportSourceApi.cancel('cancel');
      }
      this.reportSourceApi = _axios.default.CancelToken.source();
      var params = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.reportForm), {}, {
        srEmpNo: this.srEmpNo
      });
      (0, _homeReport.getReportVisitRecord)(params, this.reportSourceApi.token).then(function (res) {
        var data = res.data || {};
        var _ref3 = data || {},
          visitDayQty = _ref3.visitDayQty,
          visitQty = _ref3.visitQty;
        _this5.monthVisitReport.visitDayQty = visitDayQty || 0;
        _this5.monthVisitReport.visitQty = visitQty || 0;
      });
    },
    paddingNum: function paddingNum(inputParam) {
      return (0, _index.paddingNum)(inputParam);
    },
    // 销量报告
    fetchSaleDisplayData: function fetchSaleDisplayData() {
      var _this6 = this;
      // 数据更新时环形图先归零
      if (this.isSales === 'sales') {
        (0, _methods.drawMoney)(this.SALESChat, {});
      }
      (0, _homeReport.getSaleDisplayData)(this.salesForm).then(function (res) {
        _this6.saleDisplayData = res.data || {};
        var salesInfo = {
          finishRate: res.data.finishRate || 0
        };
        // 环状图
        if (res.data.list && res.data.list.length) {
          var target_LUX = res.data.list.find(function (t) {
            return t.title === 'LUX';
          });
          var target_SUV = res.data.list.find(function (t) {
            return t.title === 'SUV';
          });
          var target_EV = res.data.list.find(function (t) {
            return t.title === 'EV';
          });
          _this6.target_LUX = target_LUX || {};
          _this6.target_SUV = target_SUV || {};
          _this6.target_EV = target_EV || {};
        }
        // 延时更新避免动画顺序有问题
        setTimeout(function () {
          if (_this6.isSales === 'sales') {
            (0, _methods.drawMoney)(_this6.SALESChat, salesInfo);
          }
        }, 500);
      });
    },
    // 积分报告
    fetchSaleIntegralData: function fetchSaleIntegralData() {
      var _this7 = this;
      if (this.isSales === 'integral') {
        (0, _methods.drawMoney)(this.SALESChat, {});
      }
      (0, _homeReport.getSaleIntegralData)(this.salesForm).then(function (res) {
        _this7.saleIntegralData = res.data || {};
        var salesInfo = {
          finishRate: res.data.attainment || 0,
          dataValue: res.data.attainment ? (0, _index.paddingNum)(res.data.attainment) + '%' : '-%'
        };
        // 延时更新避免动画顺序有问题
        setTimeout(function () {
          if (_this7.isSales === 'integral') {
            (0, _methods.drawMoney)(_this7.SALESChat, salesInfo);
          }
        }, 500);
      });
    },
    // MIX报告
    fetchMixData: function fetchMixData() {
      var _this8 = this;
      (0, _homeReport.getMixData)(this.salesForm).then(function (res) {
        var mixData = res.data || [];
        var mixData_18 = mixData.find(function (item) {
          return item.title === '18+';
        });
        var mixData_19 = mixData.find(function (item) {
          return item.title === '19+';
        });
        var mixData_20 = mixData.find(function (item) {
          return item.title === '20+';
        });
        _this8.mixData_18 = mixData_18 || {};
        _this8.mixData_19 = mixData_19 || {};
        _this8.mixData_20 = mixData_20 || {};
      });
    },
    // 新产品
    fetchNewProductsData: function fetchNewProductsData() {
      var _this9 = this;
      (0, _homeReport.getNewProductsData)(this.salesForm).then(function (res) {
        _this9.newProductsData = res.data || [];
      });
    },
    // 门店sales部分
    fetchStoreData: function fetchStoreData() {
      var _this0 = this;
      (0, _homeReport.getStoreSRDATraining)((0, _objectSpread2.default)({}, this.salesForm)).then(function (res) {
        _this0.storeData = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, res.data), {}, {
          activeRateNum: res.data.activeCount > 0 && res.data.activeTargetCount === 0 ? 100 : res.data.activeRate && parseInt(res.data.activeRate) || 0,
          activeRate: res.data.activeTargetCount === 0 ? '-' : res.data.activeRate,
          signRateNum: res.data.signingCount > 0 && res.data.signingTargetCount === 0 ? 100 : res.data.signingRate && parseInt(res.data.signingRate) || 0,
          signRate: res.data.signingTargetCount === 0 ? '-' : res.data.signingRate
        });
      });
    },
    // 门店整体部分
    fetchStoreALLData: function fetchStoreALLData() {
      var _this1 = this;
      (0, _homeReport.getStoreData)(this.storeForm).then(function (res) {
        _this1.storeAllData = res.data || {};
      });
    },
    clickShowSalary: function clickShowSalary() {
      this.salaryRes = 0;
      this.salary = 0;
      this.showSalary = !this.showSalary;
    },
    // 奖金换算
    onBonusCalculation: function onBonusCalculation() {
      var _this10 = this;
      if (!this.salary || !this.bonusMonth) {
        this.$message.warning('请填写月薪');
        return;
      }
      (0, _homeReport.getBonusCalculation)({
        salary: this.salary,
        bonusMonth: this.bonusMonth
      }).then(function (res) {
        if (res.success) {
          _this10.salaryRes = res.data.bonus || 0;
        }
      });
    },
    getLookupTypeCode: function getLookupTypeCode() {
      var _this11 = this;
      var param = {
        configItemCodeList: ['BONUS_CALCULATION_MONTH']
      };
      this.$api.common.getConfigItemByCode(param).then(function (res) {
        if (res.data) {
          _this11.lookupList = res.data || {};

          // 查找值数据转换
          for (var key in _this11.lookupList) {
            _this11.generateMapping(key, _this11.lookupList[key] || []);
          }
        }
      }).catch(function () {});
    },
    generateMapping: function generateMapping(title, dataList) {
      var _this12 = this;
      // 将查找值转换成所需数据格式
      this.lookupList["".concat(title, "_MAPPING")] = {};
      dataList.forEach(function (item) {
        var name = item.name,
          code = item.code;
        _this12.lookupList["".concat(title, "_MAPPING")][code] = name;
      });
    }
  }
};